import { h, JSX, Ref } from "preact";
import { useEffect, useRef } from "preact/hooks";

import classname from "../../../../foundation/utils/classname";
import { useDisableAutoFillSafariBrowsers } from "../../../hooks/useDisableAutoFillSafariBrowsers";

import styles from "./InputArea.module.css";

type NativeTextAreaProps = JSX.HTMLAttributes<HTMLTextAreaElement>;

enum Variant {
    Default = "default",
    Ninja = "ninja"
}

interface Props extends NativeTextAreaProps {
    textAreaClass?: string;
    textClass?: string;
    variant?: Variant;
    inputAreaRef?: Ref<HTMLTextAreaElement>;
    showBackground?: boolean;
}

function InputArea({
    class: cssClass,
    textAreaClass,
    textClass = "body-1",
    style,
    variant = Variant.Default,
    inputAreaRef,
    autoFocus,
    disabled,
    showBackground,
    children,
    ...nativeTextAreaProps
}: Props) {
    const ref = useRef<HTMLTextAreaElement | null>(null);

    if (ref.current) {
        useDisableAutoFillSafariBrowsers(ref.current as unknown as HTMLInputElement);
    }

    useEffect(() => {
        if (autoFocus) {
            ref.current?.focus();
        }
    }, [autoFocus]);

    function handleRef(el: HTMLTextAreaElement | null) {
        ref.current = el;

        if (inputAreaRef) {
            if (typeof inputAreaRef === "function") {
                inputAreaRef(el);
            } else {
                inputAreaRef.current = el;
            }
        }
    }

    return (
        <label class={classname(styles.inputAreaWrapper, cssClass, {
            [styles.ninja]: variant === Variant.Ninja,
            [styles.disabled]: disabled,
            [styles.showBackground]: showBackground
        })} style={style}>
            <textarea
                name="dummy_name_to_prevent_autofill" // prevents safari auto fill
                class={classname(styles.inputArea, textAreaClass, textClass)}
                ref={handleRef}
                autoCorrect="off"
                autoComplete="off"
                /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
                // @ts-ignore
                autoCapitalize="off"
                spellcheck
                disabled={disabled}
                {...nativeTextAreaProps}/>
            {children}
        </label>
    );
}

export default InputArea;
export {
    Variant as InputAreaVariant
};
